<template>
  <div id="container" class="cs_st service_introduce">
    <!-- Location START -->
    <!-- TODO: ADD SUBBAR COMPONENT -->
    <!-- <BaseLocation current-group-name="information" /> -->
    <div class="background">
      <div class="section fill intro">
        <div class="background_pc c_wrap">
          <h1>
            출판사 제휴 문의
          </h1>
          <img
            src="@/assets/images/new_detailpage/Partnership/tit_under.png"
            alt=""
          />
          <p>
            캠퍼스북은 대학교재 전문 플랫폼입니다. <br />
            대학교재 출판사들의 입점을 환영합니다.
          </p>
          <a href="mailto:admin@campusbook.co.kr" class="send_btn"
            >상세 내용 받기</a
          >
        </div>
        <div class="background_pc custom_img">
          <img
            data-aos="fade-left"
            src="@/assets/images/new_detailpage/Partnership/banner_partner_char.png"
            alt=""
          />
        </div>
        <div id="background_mb">
          <h1>
            출판사 제휴 문의
          </h1>
          <img
            src="@/assets/images/new_detailpage/Partnership/tit_under.png"
            alt=""
          />
          <p>
            캠퍼스북은 대학교재<br />
            전문 플랫폼입니다. <br />
            대학교재 출판사들의 입점을<br />
            환영합니다.
          </p>
        </div>
      </div>
      <img
        src="@/assets/images/new_detailpage/Partnership/Partnership_banner_mb1.png"
        alt=""
        class="banner_mb1"
      />
      <img
        src="@/assets/images/new_detailpage/Partnership/Partnership_banner_mb2.png"
        alt=""
        class="banner_mb2"
      />
      <img
        src="@/assets/images/new_detailpage/Partnership/Partnership_banner_mb3.png"
        alt=""
        class="banner_mb3"
      />
    </div>
    <div class="background2">
      <div class="section fill intro">
        <div class="background_pc">
          <p>
            캠퍼스북은 대학교재 전자책을 원하는 많은 학생, <br />
            교·강사 분들의 니즈에 맞춰 학습에 필요한 기능을<br />
            포함한 대학교재 전자책 유통 플랫폼입니다.
          </p>
          <h1>
            대학교재의 디지털화로 보다 편리하고 접근성을 높인<br />
            학습서비스를 제공하는 것이 캠퍼스북의 목표입니다.
          </h1>
          <img
            data-aos="fade-up"
            class="banner_icon"
            src="@/assets/images/new_detailpage/Partnership/banner_icon.png"
            alt=""
          />
          <img
            class="banner_icon1"
            src="@/assets/images/new_detailpage/Partnership/banner_icon1.png"
            alt=""
          />
          <img
            class="banner_icon2"
            src="@/assets/images/new_detailpage/Partnership/banner_icon2.png"
            alt=""
          />
        </div>
        <div id="background_mb">
          <p>
            캠퍼스북은 대학교재<br />
            전자책을 원하는 많은 학생, <br />
            교·강사 분들의 니즈에 맞춰 학습에<br />
            필요한 기능을 포함한 <br />대학교재 전자책 유통 플랫폼입니다.
          </p>
          <h1>
            대학교재의 디지털화로<br />
            보다 편리하고 접근성을 높인<br />
            학습서비스를 제공하는 것이<br />
            캠퍼스북의 목표입니다.
          </h1>
          <div class="banner_icon_wrap">
            <img
              class="banner_icon"
              data-aos="fade-up"
              src="@/assets/images/new_detailpage/Partnership/banner_icon.png"
              alt=""
            />
          </div>
          <img
            class="banner_icon1"
            src="@/assets/images/new_detailpage/Partnership/banner_icon1.png"
            alt=""
          />
          <img
            class="banner_icon2"
            src="@/assets/images/new_detailpage/Partnership/banner_icon2.png"
            alt=""
          />
        </div>
      </div>
    </div>

    <div class="section_wrap">
      <div class="section1">
        <div class="section_box">
          <span class="tit bg_blue pc_p">캠퍼스북은 무엇이 좋을까요?</span>
          <span class="mb_p tit"
            ><span class="bg_blue" style="padding: 0 10px;">
              캠퍼스북은
            </span>
            <div class="bg_blue" style="padding: 0 10px; margin-top: 10px;">
              무엇이 좋을까요?
            </div>
          </span>
          <div class="section_cont">
            <ul data-aos="fade-up">
              <li>
                <img
                  src="@/assets/images/new_detailpage/Partnership/section1-1.png"
                  alt=""
                />
                <h5 class="bg_blue">증정 서비스</h5>
                <p>
                  교재 채택 시 교·강사 분들에게 <br />
                  강의교재를 무료로 제공하는 <br />
                  신속한 증정시스템을 <br />
                  도입하고 있습니다.
                </p>
              </li>
              <li>
                <img
                  src="@/assets/images/new_detailpage/Partnership/section1-2.png"
                  alt=""
                />
                <h5 class="bg_blue">비용 절감</h5>
                <p>
                  전자책은 인쇄, 배송, 재고 <br />
                  걱정 없이 관리 가능합니다.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="section2">
        <div class="section_box">
          <span class="tit bg_pink pc_p">무거웠던 전공교재를 전자책으로!</span>
          <span class="mb_p tit"
            ><div class="bg_pink" style="padding: 0 10px; margin-bottom: 10px;">
              무거웠던 전공교재를
            </div>
            <span class="bg_pink" style="padding: 0 10px;">
              전자책으로 !
            </span>
          </span>
          <div class="section_cont" data-aos="fade-up">
            <img
              src="@/assets/images/new_detailpage/Partnership/section2.png"
              alt=""
              class="pc_p"
            />
            <img
              src="@/assets/images/new_detailpage/Partnership/mb_section2.png"
              alt=""
              class="mb_p"
            />
            <span class="tit">효과적인 학습기능</span>
            <p class="pc_p">캠퍼스북만의 효과적인 학습 기능을 제공합니다.</p>
            <p class="mb_p">
              캠퍼스북만의 효과적인 <br />학습 기능을 제공합니다.
            </p>
          </div>
        </div>
      </div>
      <div class="section3">
        <div class="section_box">
          <div class="section_cont">
            <img
              src="@/assets/images/new_detailpage/Partnership/section3.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="section3-1">
        <div class="section_box">
          <div class="section_cont">
            <img
              src="@/assets/images/new_detailpage/Partnership/mb_section3.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="section3-2">
        <div class="section_box">
          <div class="section_cont">
            <img
              src="@/assets/images/new_detailpage/Partnership/mb_section4.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="section4">
        <div class="section_box">
          <div class="section_cont">
            <span class="tit">캠퍼스북만의 특화된 마이노트는</span>
            <p>
              교재 안에서 다양한 기록이 가능한<br />
              학습에 최적화된 기능입니다.
            </p>
            <img
              data-aos="fade-up"
              src="@/assets/images/new_detailpage/Partnership/section4.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="section5">
        <div class="section_box">
          <div class="section_cont pc_p">
            <div style="margin-bottom: 100px;" data-aos="fade-up">
              <img
                src="@/assets/images/new_detailpage/Partnership/section5-1.png"
                alt=""
              />
              <div class="sc5_text">
                <span class="bg_blue"
                  >전자책 때문에 종이책 매출이 걱정되신다구요?</span
                >
                <p>
                  불법복제와 전자파일 유출로 막심한 피해를 입는<br />
                  출판사들에게 전자책의 정상적인 서비스로 <br />
                  저작권을 보호하여 매출 증대 효과를 <br />
                  기대할 수 있습니다.
                </p>
              </div>
            </div>
            <div data-aos="fade-up">
              <div class="sc5_text">
                <p>
                  다운로드해서 보는 방식이 아닌<br />
                  <em class="bg_blue">스트리밍 방식</em> 으로 파일유출 <br />
                  위험이 없습니다. 또한 동시접속을 막아 <br />
                  <em class="bg_blue">출판사의 권리를 보호</em>하고 있습니다.
                </p>
              </div>
              <img
                src="@/assets/images/new_detailpage/Partnership/section5-2.png"
                alt=""
                style="margin-top: -50px;"
              />
            </div>
          </div>
          <div class="section_cont mb_p">
            <div style="margin-bottom: 100px;">
              <div class="sc5_text">
                <img
                  src="@/assets/images/new_detailpage/Partnership/section5-1.png"
                  alt=""
                  style="width: 210px;"
                />
                <span class="mb_p tit"
                  ><span class="bg_blue" style="padding: 0 3px;">
                    전자책 때문에 종이책
                  </span>
                  <div
                    class="bg_blue"
                    style="padding: 0 3px; margin-top: 10px;"
                  >
                    매출이 걱정되신다구요?!
                  </div>
                </span>
                <p>
                  불법복제와 전자파일 유출로<br />
                  막심한 피해를 입는 출판사들에게<br />
                  전자책의 정상적인 서비스로 <br />
                  저작권을 보호하여 매출 증대 효과를 <br />
                  기대할 수 있습니다.
                </p>
              </div>
            </div>
            <div>
              <div class="sc5_text">
                <img
                  src="@/assets/images/new_detailpage/Partnership/mb_section5-2.png"
                  style="width: 134px; margin-bottom: 50px;"
                  alt=""
                />
                <p>
                  다운로드해서 보는 방식이 아닌<br />
                  <em class="bg_blue">스트리밍 방식</em> 으로 파일유출 <br />
                  위험이 없습니다. 또한 동시접속을 막아 <br />
                  <em class="bg_blue">출판사의 권리를 보호</em>하고 있습니다.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section6">
        <div class="section_box">
          <span class="tit bg_pink pc_p"
            >캠퍼스북, 입점 과정은 어떻게 되나요?</span
          >
          <span class="mb_p tit"
            ><span class="bg_pink" style="padding: 0 10px;">
              캠퍼스북,
            </span>
            <div class="bg_pink" style="padding: 0 10px; margin-top: 10px;">
              입점 과정은 어떻게 되나요?
            </div>
          </span>
          <div class="section_cont">
            <ul>
              <li>
                <img
                  src="@/assets/images/new_detailpage/Partnership/section6-1.png"
                  alt=""
                />
                <p>
                  컨택 포인트 제출
                </p>
              </li>
              <li>
                <img
                  src="@/assets/images/new_detailpage/Partnership/section6-2.png"
                  alt=""
                />
                <p>캠퍼스북에서 <br />컨택(3일 이내)</p>
              </li>
              <li>
                <img
                  src="@/assets/images/new_detailpage/Partnership/section6-3.png"
                  alt=""
                />
                <p>
                  검토 및 계약
                </p>
              </li>
              <li>
                <img
                  src="@/assets/images/new_detailpage/Partnership/section6-4.png"
                  alt=""
                />
                <p>
                  전자책 제작 후 판매
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="section7">
        <div class="section_box" data-aos="fade">
          <span class="tit">제휴 문의하기</span>
          <div class="section_cont pc_p">
            <p>제안을 보내주세요. 검토 후 담당자를 통해서 연락 드리겠습니다.</p>
          </div>
          <div class="section_cont mb_p">
            <img
              src="@/assets/images/new_detailpage/Partnership/mb_sectoin8.png"
              alt=""
            />
            <p>
              제안을 보내주세요. <br />검토 후 담당자를 통해서<br />
              연락 드리겠습니다.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="f_banner">
      <div class="section fill pc_f_banner">
        <h4>
          캠퍼스북은 <em>대학교재 전문 플랫폼</em> 입니다. <br />
          <em>대학교재, 학술서적 위주로 모집</em> 하는 점 참고해주세요.
        </h4>
      </div>
      <div class="section fill mb_f_banner">
        <h4>
          캠퍼스북은 대학교재<br />
          전문 플랫폼 입니다. <br />
          대학교재, 학술서적 위주로<br />
          모집 하는 점 참고해주세요.
        </h4>
      </div>
    </div>
  </div>
</template>

<script>
// import { Swiper } from 'swiper/vue'
import AOS from 'aos'
import 'aos/dist/aos.css'
export default {
  name: 'Guide',
  data() {
    return {}
  },
  computed: {
    viewerSwiper() {
      return this.$refs.viewerSwiper.$swiper
    },
    ebookSwiper() {
      return this.$refs.ebookSwiper.$swiper
    }
  },
  mounted() {
    AOS.init()
    // let that = this
    // that.mySwiper.on('init', () => {
    //   that.getActiveIndex(this)
    //   console.log(that.getActiveIndex(this))
    // })
  },

  methods: {
    toggleListMenu() {
      this.showListMenu = !this.showListMenu
    },
    closeListMenu() {
      this.showListMenu = false
    },
    activeIndexChange(i) {
      console.log(i)
    },
    slideChangeEbook() {
      this.eBookPg = parseInt(this.ebookSwiper.activeIndex) + 1
    },
    slideChangeViewer() {
      this.viewerPg = parseInt(this.viewerSwiper.activeIndex) + 1
    }
  }
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: 'NanumSquare';
  font-weight: 400;
  src: url('../../../src/assets/fonts/NanumSquareR.otf') format('otf'),
    url('../../../src/assets/fonts/NanumSquareR.ttf') format('woff2'),
    url('../../../src/assets/fonts/NanumSquareR.ttf') format('woff'),
    url('../../../src/assets/fonts/NanumSquareR.ttf') format('ttf');
}
@font-face {
  font-family: 'NanumSquare';
  font-weight: 300;
  src: url('../../../src/assets/fonts/NanumSquareL.otf') format('otf'),
    url('../../../src/assets/fonts/NanumSquareL.ttf') format('woff2'),
    url('../../../src/assets/fonts/NanumSquareL.ttf') format('woff'),
    url('../../../src/assets/fonts/NanumSquareL.ttf') format('ttf');
}
@font-face {
  font-family: 'NanumSquare';
  font-weight: 700;
  src: url('../../../src/assets/fonts/NanumSquareB.otf') format('otf'),
    url('../../../src/assets/fonts/NanumSquareB.ttf') format('woff2'),
    url('../../../src/assets/fonts/NanumSquareB.ttf') format('woff'),
    url('../../../src/assets/fonts/NanumSquareB.ttf') format('ttf');
}
@font-face {
  font-family: 'NanumSquare';
  font-weight: 800;
  src: url('../../../src/assets/fonts/NanumSquareEB.otf') format('otf'),
    url('../../../src/assets/fonts/NanumSquareEB.ttf') format('woff2'),
    url('../../../src/assets/fonts/NanumSquareEB.ttf') format('woff'),
    url('../../../src/assets/fonts/NanumSquareEB.ttf') format('ttf');
}

body,
h1,
h4,
p {
  font-family: 'pretendard-light';
}

.bg_pink {
  background: linear-gradient(
    to top,
    rgba(244, 159, 189, 0.4) 50%,
    transparent 50%
  );
}

.bg_blue {
  background: linear-gradient(
    to top,
    rgba(102, 196, 255, 0.4) 50%,
    transparent 50%
  );
}

.mb_p {
  display: none;
}

#background_mb {
  display: none;
}
.banner_mb1,
.banner_mb2,
.banner_mb3 {
  display: none;
}

.section3-1,
.section3-2 {
  display: none;
}

.section_wrap .tit.mb_p {
  display: none;
}

.mb_f_banner {
  display: none;
}

.section.fill {
  width: 100%;
  max-width: 1120px;
  background: none;
}

.cs_st.service_introduce .background {
  background: url('../../assets/images/new_detailpage/Partnership/banner_partner.png')
    center no-repeat;
  background-size: contain;
  @media screen and (min-width: 830px) {
    background-size: 100% 100%;
    // max-width: 1920px;
    // margin: 0 auto;
  }
  .intro.fill {
    height: 630px;
    @media screen and (min-width: 830px) {
      // height: calc(33.802083vw - (var(--scrollbar-width) / 100vw));
      height: 33.802083vw;
    }
    background: none;
    h1 {
      font-size: 2.5em;
      margin-bottom: 20px;
      color: #3b4baa;
      padding-top: 0px;
    }
    p {
      font-size: 1.714em;
      padding-top: 40px;
      font-weight: bold;
      color: #878787;
    }
  }
}
.background .background_pc {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
  &.custom_img {
    height: 80%;
    top: 10%;
    left: calc(38% + 20vw);
    transform: none;
    > img {
      height: 100%;
    }
  }
}
.background2 {
  background-color: #7485f7;
  text-align: center;
  box-sizing: border-box;
  position: relative;
  .intro.fill {
    height: 590px;
    background: none;
    p {
      color: #ffef29;
      font-size: 24px;
      padding-top: 112px;
      font-weight: lighter;
    }
    h1 {
      font-family: 'pretendard-medium';
      font-size: 26px;
      padding-top: 50px;
      font-weight: 600;
      line-height: 40px;
    }
    .banner_icon {
      position: absolute;
      bottom: -106px;
      left: calc(50% - 190px);
      // transform: translate(%, -50%);
      width: 379px;
    }
    .banner_icon1 {
      position: absolute;
      top: 14%;
      left: 18%;
      width: 47px;
    }
    .banner_icon2 {
      position: absolute;
      top: 72%;
      left: 79%;
      width: 34px;
    }
  }
}

.section_wrap {
  text-align: center;
  .tit {
    font-size: 32px;
    padding: 0 15px 10px;
    display: inline-block;
    margin-bottom: 100px;
    font-weight: bold;
  }
  .section_cont {
    margin: auto;
    max-width: 1120px;
  }
}
.section1 {
  background-color: #f1f2fd;
  padding: 280px 0 100px;
  .section_cont {
    max-width: 660px;
    ul {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      li {
        font-weight: bold;
        img {
          max-width: 250px;
        }
        h5 {
          width: 142px;
          margin: 30px auto;
          font-size: 22px;
          color: #4039eb;
        }
        p {
          font-size: 17px;
          line-height: 28px;
        }
      }
    }
  }
}
.section2 {
  padding: 120px 0;
  .section_cont {
    .mb_p {
      display: none;
    }
    img {
      max-width: 800px;
      display: block;
      width: 100%;
      margin: 0 auto 50px;
    }
    .tit {
      margin-bottom: 10px;
    }
    p {
      font-size: 25px;
    }
  }
}
.section3 {
  background-color: #fff8fa;
  img {
    max-width: 1120px;
    width: 100%;
  }
}
.section4 {
  padding: 100px 0;
  .section_cont {
    padding: 90px 50px;
    max-height: 568px;
    max-width: 870px;
    background-color: #e2e2e2;
    border-radius: 70px;
    .tit {
      margin-bottom: 10px;
      font-size: 30px;
    }
    p {
      font-size: 23px;
      margin-bottom: 30px;
    }
    img {
      max-width: 644px;
      width: 100%;
    }
  }
}
.section5 {
  background-color: #f1f2fd;
  padding: 100px 0;
  .section_cont {
    div {
      img {
        max-width: 240px;
        vertical-align: top;
        margin: -20px 60px;
      }
      .sc5_text {
        text-align: left;
        display: inline-block;
        font-weight: bold;
        span {
          font-size: 21px;
        }
        p {
          font-size: 19px;
          margin-top: 15px;
          color: #7b8387;
          line-height: 33px;
        }
      }
    }
  }
}
.section6 {
  background-color: #fff8fa;
  padding: 120px 0;
  .section_cont {
    max-width: 800px;
    ul {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      li {
        font-weight: bold;
        img {
          max-width: 134px;
        }
        p {
          margin-top: 20px;
          font-size: 18px;
        }
      }
    }
  }
}
.section7 {
  background-color: #f9f5f2;
  padding: 95px;
  .tit {
    margin-bottom: 20px;
    font-size: 30px;
  }
  p {
    font-size: 20px;
    color: #5b5b5b;
    font-weight: 900;
  }
}

.f_banner {
  width: 100%;
  padding: 65px 0;
  color: #e0e0e0;
  background: url('../../assets/images/new_detailpage/f_banner.png') center
    no-repeat;
  background-size: cover;
  text-align: center;
  font-weight: 900;

  .section.fill {
    background: none;
  }

  h4 {
    font-size: 23px;
    line-height: 38px;
    em {
      color: #fff;
      font-size: 24px;
    }
  }
}

@media (max-width: 1120px) {
  .cs_st.service_introduce .intro p {
    line-height: 36px;
  }
  .background .background_pc {
    position: absolute;
    top: 50%;
    left: 50px;
    transform: translate(0, -50%);
  }
  .section_wrap > div {
    padding-left: 50px;
    padding-right: 50px;
  }
}

@media (max-width: 830px) {
  .cs_st.service_introduce .introduce_cont p {
    padding-top: 0;
  }
  .background_pc {
    display: none;
  }

  #background_mb {
    display: block;
  }

  .banner_mb1,
  .banner_mb2,
  .banner_mb3 {
    display: block;
  }

  .section3 {
    display: none;
  }
  .section3-1,
  .section3-2 {
    display: block;
  }

  .section_wrap .tit.pc_p {
    display: none;
  }
  .section_wrap .tit.mb_p {
    display: inline-block;
  }
  .section_wrap .pc_p {
    display: none;
  }
  .section_wrap .mb_p {
    display: block;
  }

  .mb_f_banner {
    display: block;
  }

  .pc_f_banner {
    display: none;
  }

  .cs_st.service_introduce .background {
    background: none;
    background-color: #f1f2fd;
    height: 750px;
    position: relative;
    #background_mb {
      position: absolute;
      top: 50%;
      left: 0px;
      padding-left: 30px;
      transform: translate(0, -50%);
      h1 {
        margin-bottom: 5px;
        font-size: 30px;
      }
      p {
        font-size: 22px;
        line-height: 35px;
      }
    }
    .banner_mb1,
    .banner_mb2 {
      position: absolute;
      width: 330px;
    }
    .banner_mb1 {
      top: 0px;
      right: -110px;
    }
    .banner_mb2 {
      bottom: 0;
      left: -50px;
    }
    .banner_mb3 {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, 0);
    }
  }
  .cs_st.service_introduce .background2 {
    // height: 620px;
    #background_mb {
      h1 {
        padding-top: 40px;
        font-size: 22px;
        line-height: 32px;
      }
      p {
        font-size: 20px;
        color: #ffef29;
        padding-top: 130px;
        line-height: 30px;
      }
      .banner_icon {
        position: static;
        max-width: 280px;
        top: 92%;
        left: calc(50% - 140px);
        // transform: translate(-50%, 0%);
      }
      .banner_icon1 {
        position: absolute;
        top: 12%;
        left: 10%;
        width: 37px;
      }
      .banner_icon2 {
        position: absolute;
        top: 84%;
        left: 82%;
        width: 27px;
      }
    }
  }

  .section_wrap {
    text-align: center;
    .tit {
      font-size: 22px;
      padding: 0 15px 10px;
      display: inline-block;
      margin-bottom: 60px;
      font-weight: bold;
    }
    .section_cont {
      margin: auto;
      max-width: 1120px;
    }
  }
  .section1 {
    padding: 180px 0 10px;
    .section_cont {
      ul {
        justify-content: space-around;
        li {
          font-weight: bold;
          margin-bottom: 70px;
          img {
            max-width: 196px;
          }
          h5 {
            width: 142px;
            margin: 30px auto;
            font-size: 22px;
            color: #4039eb;
          }
          p {
            font-size: 17px;
            line-height: 28px;
          }
        }
      }
    }
  }
  .section2 {
    padding: 80px 0;
    .section_cont {
      .pc_p {
        display: none;
      }
      .mb_p {
        display: block;
      }
      img {
        max-width: 190px;
      }
      .tit {
        margin-bottom: 10px;
        font-size: 23px;
      }
      p {
        font-size: 21px;
      }
    }
  }
  .section3-1 {
    background-color: #fff8fa;
    padding-top: 50px;
    margin-bottom: 90px;
    img {
      max-width: 330px;
      width: 100%;
    }
  }
  .section3-2 {
    background-color: #fbfaff;
    padding-bottom: 30px;
    img {
      max-width: 330px;
      width: 100%;
    }
  }
  .section_wrap .section4 {
    padding: 100px 20px;
    .section_cont {
      padding: 60px 10px 0;
      border-radius: 30px;
      .tit {
        margin-bottom: 0px;
        font-size: 18px;
      }
      p {
        font-size: 18px;
        margin-bottom: 30px;
        line-height: 26px;
      }
      img {
        max-width: 400px;
        width: 100%;
      }
    }
  }
  .section5 {
    background-color: #f1f2fd;
    padding: 100px 0;
    .section_cont {
      div {
        .sc5_text {
          text-align: left;
          display: block;
          font-weight: bold;
          img {
            max-width: 240px;
            margin: 0 auto;
            display: block;
          }
          .tit {
            margin-bottom: 0;
            margin-top: 70px;
            padding: 0;
          }
          span {
            font-size: 22px;
          }
          p {
            font-size: 18px;
            line-height: 35px;
          }
        }
      }
    }
  }
  .section6 {
    .section_cont {
      ul {
        li {
          margin-top: 50px;
          font-weight: bold;
          width: 100%;
          img {
            max-width: 116px;
          }
          p {
            margin-top: 20px;
          }
        }
        li:first-child {
          margin-top: 0px;
        }
      }
    }
  }
  .section7 {
    text-align: left;
    padding: 60px;
    .tit {
      margin-bottom: 40px;
      font-size: 30px;
      padding: 0;
    }
    img {
      vertical-align: middle;
      padding-right: 10px;
      display: block;
      float: left;
    }
    p {
      line-height: 33px;
    }
  }

  .f_banner {
    padding: 50px 30px;
  }

  .f_banner .mb_f_banner {
    text-align: left;
    h4 {
      font-size: 20px;
      line-height: 33px;
    }
  }
  .banner_icon_wrap {
    margin-top: 40px;
  }
}
.send_btn {
  width: 196px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #3b4baa;
  border-radius: 17px;
  color: #fff894;
  font-size: 20px;
  margin-top: 16px;
}
@media screen and (min-width: 831px) and (max-width: 1280px) {
  .c_wrap {
    > h1 {
      font-size: 2em !important;
      margin-bottom: 16px !important;
    }
    > p {
      font-size: 1.375em !important;
      padding-top: 28px !important;
    }
  }
}
@media (max-width: 767px) {
  .cs_st.service_introduce .intro.fill {
    height: auto;
    padding-bottom: 130px;
  }
}
</style>
